import React from "react";
import "../styles/AlertPopUpStyles.css"; // Import styles
import tapImg from "../assets/images/assessment/assessment_popup_tab.png";
import bgImg from "../assets/images/assessment/assessment_popup_bg.jpg";
import arrowImg from "../assets/images/assessment/arrowImg.png";

interface PopupProps {
  title: string;
  body: string;
  onClose: () => void;
}

const AlertPopup: React.FC<PopupProps> = ({ title, body, onClose }) => {
  return (
    <div className="alertpopup-overlay">
      <div className="alertpopup-container">
        <div className="alertpopup-header">
          <h2>{title}</h2>
        </div>
        <div
          className="alertpopup-body"
          style={{
            display: "flex",
            flexDirection: "column", // Arrange children in a column
            margin: "0",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            backgroundImage: `url(${bgImg})`, // Replace with your image URL
            backgroundSize: "cover", // Ensure the image covers the entire background
            backgroundRepeat: "no-repeat", // Prevent the image from repeating
            backgroundPosition: "center", // Center the image
            padding: "20px", // Optional: Add padding for spacing
          }}
        >
          <div>
            <img
              src={tapImg} // Replace with your image URL
              alt="description" // Add alt text for accessibility
              style={{
                width: "400px",
                height: "100px",
                marginBottom: "10px", // Add margin below the image
              }}
            />
          </div>
          <div>
            <p
              style={{
                textAlign: "center",
                color: "#353535",
                fontFamily: "Mazzard",
                fontSize: "20px",
                fontWeight: "400",
                marginTop: "10px", // Add margin above the text for spacing
              }}
            >
              {body}
            </p>
          </div>
        </div>

        <div className="alertpopup-footer">
          <button onClick={onClose} className="alertpopup-button">
            Go to assessment{" "}
            <img
              src={arrowImg}
              alt="Arrow"
              style={{
                width: "40px", // Adjust the size of the arrow image as needed
                height: "20px", // Ensure the height is consistent with the width
                marginLeft: "10px", // Add some space between the text and the image
              }}
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertPopup;
